import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import blogPostBbThumbnail from "../../../../img/bb-marketing-thumbnail-small.png";
import userThumbnail from "../../../../img/user-icon.svg";
import "./style.scss";

const Index = () => {
  const blogPosts = [
    {
      id: 0,
      thumbnail: blogPostBbThumbnail,
      title:
        "Slik brukte B&B Marketing Leadfind for å skaffe nye kunder og øke salget",
      excerpt:
        "Hvis du leter etter et salgsverktøy for å skape nye potensielle kunder, er Leadfind definitivt verdt å prøve ut. Leadsurf lar deg lage e-postkampanjer og målrette deg mot potensielle kunder med laserpresisjon..",
      url: "/blogg/slik-brukte-bb-marketing-leadfind-for-å-skaffe-nye-kunder-og-øke-salget",
    },
  ];

  return (
    <div className="blog-collection-container">
      <div className="inner-blog-collection-container">
        <Row className="blog-collection-row">
          {blogPosts.map((blogPost) => (
            <Col md={4} className="single-article-col">
              <Link to={blogPost.url}>
                <div className="inner-single-article-col">
                  <img className="article-thumbnail" src={blogPost.thumbnail} />
                  <div className="author-container">
                    <Row>
                      <Col className="text-left">
                        <span className="author-icon">
                          <img className="icon" src={userThumbnail} />
                        </span>
                        <span className="author-name">Erlend Bognøy</span>
                      </Col>
                      <Col className="text-right">
                        <span className="author-type">Gjesteinnlegg</span>
                        <span className="author-published">
                          <i class="fa-regular fa-calendar-range"></i> 9. April
                          2022
                        </span>
                      </Col>
                    </Row>
                  </div>
                  <h2 className="article-title">{blogPost.title}</h2>
                  <p className="article-excerpt">{blogPost.excerpt}</p>
                </div>
              </Link>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default Index;
